import axios from "axios";
import { notifyError } from "../components/message/message";

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const api = {
  get: async (url, params) => {
    try {
      const { data, status } = await client.get(url, getConfigs(params));
      let newData = data;
      newData.status = status;
      return newData;
    } catch (error) {
      handleError(error);
      return { success: false };
    }

  },
  post: async (url, body) => {
    try {
      const { data } = await client.post(url, body, getConfigs());
      return data;
    } catch (error) {
      handleError(error);
      return { success: false };
    }
  },
  put: async (url, body) => {
    try {
      const { data } = await client.put(url, body, getConfigs());
      return data;
    } catch (error) {
      handleError(error);
      return { success: false };
    }
  },
  delete: async (url, config = {}) => {
    try {
      const finalConfig = {
        ...getConfigs(),
        ...config,       
      };
  
      const { data } = await client.delete(url, finalConfig);
      return data;
    } catch (error) {
      handleError(error);
      return { success: false };
    }
  }
  
};

function getConfigs(params) {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("TOKEN_KEY"),
      "Content-Type": "application/json",
    },
    params,
  };
}

function handleError(error) {
  const messages = error?.response?.data?.messages;

  if (!Array.isArray(messages) || messages.length === 0) {
    notifyError("Não foi possível realizar a ação.");
    return;
  }

  messages.forEach((msg) => {
    notifyError(msg);
  });
}

export default api;
